import request from "@/utils/request";
// var host = "https://kids.zdapk.cn/";
var host = "";
// color_type
export function colorTypeList(params) {
  return request({
    method: "POST",
    // url: host + "/Api/Book/color_type",
    url: host + "/Api/PartyPackage/party_lists",
    data: params
  });
}
export function tableclothColor(params) {
  return request({
    method: "POST",
    url: host + "/Api/Book/tablecloth_color",
    data: params
  });
}
export function provide(params) {
  return request({
    method: "POST",
    url: host + "/Api/Book/provide",
    data: params
  });
}
export function bookList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Book/book_list",
    data: params
  });
}

export function roomList(params) {
  return request({
    method: "POST",
    url: host + "/Api/Book/room_list",
    data: params
  });
}

export function productServiceList(params) {
  return request({
    method: "POST",
    url: host + "/Api/PartyPackage/product_service",
    data: params
  });
}

export function addBook(params) {
  return request({
    method: "POST",
    url: host + "/Api/Book/book_add",
    data: params
  });
}

export function payment(params) {
  return request({
    method: "POST",
    url: host + "/Api/Book/payment",
    data: params
  });
}

export function partyPackageDetail(params) {
  return request({
    method: "POST",
    url: host + `/Api/PartyPackage/detail/${params}`,
    data: {}
  });
}

export function bookConfig(params) {
  return request({
    method: "POST",
    url: host + `/Api/Book/config`,
    data: params
  });
}



export function bookDetail(params) {
  return request({
    method: "POST",
    url: host + `/Api/Book/book_detail/${params}`,
    data: {}
  });
}

export function bookCancel(id, params) {
  return request({
    method: "POST",
    url: host + `/Api/Book/book_cancel/${id}`,
    data: params
  });
}

// PartyPackage/product_category
export function getProductCategory(params) {
  return request({
    method: "POST",
    url: host + `/Api/PartyPackage/product_category`,
    data: params
  });
}
// PartyPackage/product_servic
export function getProductService(params) {
  return request({
    method: "POST",
    url: host + `/Api/PartyPackage/product_service`,
    data: params
  });
}
// 获取免费数据
export function getAdditionalService(params) {
  return request({
    method: "POST",
    url: host + `/Api/PartyPackage/additional_service`,
    data: params
  });
}


// WEBPACK FOOTER //
// ./src/server/book.js